import { TabsContent } from "@/components/ui/tabs";
import { CareCoordination } from "@/components/individual/CareCoordination";
import { FamilyMonitoring } from "@/components/individual/FamilyMonitoring";
import { SupportResources } from "@/components/individual/SupportResources";
import { Suspense } from "react";
import { FamilyPageSkeleton } from "@/components/layout/FamilyPageSkeleton";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const TabContent = () => {
  return (
    <Suspense fallback={<FamilyPageSkeleton />}>
      <TabsContent value="dashboard" className="animate-fade-in">
        <div className="space-y-8">
          <div className="grid md:grid-cols-2 gap-6">
            <Card>
              <CardHeader>
                <CardTitle>Key Metrics</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">Health metrics and insights will be displayed here.</p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Rachel Insights</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">AI-powered health insights coming soon.</p>
              </CardContent>
            </Card>
          </div>

          <Card>
            <CardHeader>
              <CardTitle>Digital Twin</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">Advanced patient modeling and predictions.</p>
            </CardContent>
          </Card>
        </div>
      </TabsContent>
      
      <TabsContent value="care" className="animate-fade-in">
        <CareCoordination />
      </TabsContent>
      
      <TabsContent value="activity" className="animate-fade-in">
        <FamilyMonitoring />
      </TabsContent>
      
      <TabsContent value="communication" className="animate-fade-in">
        <CareCoordination />
      </TabsContent>
      
      <TabsContent value="support" className="animate-fade-in">
        <SupportResources />
      </TabsContent>
    </Suspense>
  );
};